module.exports = __webpack_public_path__ + "media/contagion.1b811ef3.mp3";